import React from "react";

import Image_one from "../assets/slider-1.jpg";
import Image_two from "../assets/slider-2.jpg";
import Image_three from "../assets/slider-3.jpg";

const allImages = [Image_one, Image_two, Image_three];

function MainCarousel(props) {
  return (
    <div className="max-width-720 mx-auto pb-5" style={{ marginTop: "-115px" }}>
      <div
        id="convinientWayIndicators"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-indicators" style={{ bottom: "-60px" }}>
          {[0, 1, 2].map((i) => (
            <button
              key={i}
              type="button"
              data-bs-target="#convinientWayIndicators"
              data-bs-slide-to={i}
              className={`bg-primary height-8 rounded-10 ${
                i === 0 ? "active" : ""
              }`}
              aria-current={i === 0 ? "true" : ""}
              aria-label={`Slide ${i + 1}`}
            ></button>
          ))}
        </div>

        <div className="carousel-inner">
          {allImages.map((img, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <img src={img} className="d-block w-100" alt={index} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MainCarousel;
